module.exports = __webpack_public_path__ + "assets/week_chevron_left.ef9f1d1c.svg";